// extracted by mini-css-extract-plugin
module.exports = {"triangle":"a1w_z","outer":"_2x_PP","inner":"_3aIIa","right":"vLC9v","left":"_1qYYe"};